/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import _ from "lodash";
import reportStatement from "../assets/reportStatements.json";

export const getEsignStatements = (search) => {
  if (_.isEmpty(search)) return [];

  const matchingIds = reportStatement.reduce((accumulator, current) => {
    const statements = current?.esignStatements.filter((statement) => {
      return statement?.conclusionStatement.toLowerCase().includes(search.toLowerCase());
    });
    return [...accumulator, ...statements.map((__) => __.id)];
  }, []);

  return matchingIds;
};
